import { TextField } from "../../../../shared";
import { Grid } from "@mui/joy";

export function CustomerDetails() {
    return (
        <Grid container spacing={2} mt={0} width={"100%"}>
            <Grid xs={12}>
                <TextField
                    label={"Customer Name"}
                    helperText={"Name of the Customer"}
                    placeholder={"Jane Doe"}
                    name={"customerName"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Phone Number"}
                    helperText={"Contact number"}
                    startDecorator={"+1"}
                    placeholder={"9123456789"}
                    name={"customerPhoneNumber"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Email"}
                    helperText={"Email"}
                    placeholder={"jane.doe@roofinmotion.com"}
                    name={"customerEmail"}
                />
            </Grid>
            <Grid xs={12}>
                <TextField
                    label={"Customer Street Address"}
                    helperText={"Street name and house/building number of the customer"}
                    placeholder={"123 Main St"}
                    name={"customerStreetAddress"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Customer City"}
                    helperText={"City where the customer is located"}
                    placeholder={"Denver"}
                    name={"customerCity"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Customer State"}
                    helperText={"State where the customer is located"}
                    placeholder={"CO"}
                    name={"customerState"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Customer ZIP Code"}
                    helperText={"5-digit ZIP code of the customer"}
                    placeholder={"80202"}
                    name={"customerZipCode"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Customer County"}
                    helperText={"County where the customer is located"}
                    placeholder={"Denver County"}
                    name={"customerCountry"}
                />
            </Grid>
        </Grid>
    );
}
